import {
  Badge,
  Box,
  MantineColor,
  PasswordInputProps,
  TextInput as MantineTextInput,
  TextInputProps as MantineTextInputProps,
  useMantineTheme,
} from '@mantine/core';
import { ReactNode, useMemo, useState } from 'react';

import classes from './TextInput.module.css';

interface TextInputProps extends MantineTextInputProps, Omit<PasswordInputProps, 'classNames' | 'styles' | 'vars'> {
  badgeMessage?: string;
  badgeIcon?: ReactNode;
  badgeColor?: MantineColor;
  'data-pw'?: string;
}

export const TextInput: React.FC<TextInputProps> = (props) => {
  const mantineTheme = useMantineTheme();
  const [focused, setFocused] = useState(false);

  const floating = useMemo(() => {
    if (typeof props.value === 'string') {
      return props.value.trim().length !== 0 || focused ? true : undefined;
    }

    if (typeof props.value === 'number') {
      return !Number.isNaN(props.value) ? true : undefined;
    }

    return focused || undefined;
  }, [props.value, focused]);

  const handleFocus = (evt) => {
    setFocused(true);
    props.onFocus?.(evt);
  };

  const handleBlur = (evt) => {
    setFocused(false);
    props.onBlur?.(evt);
  };

  return (
    <Box className={classes.container} mr={props.badgeMessage && mantineTheme.spacing.xs}>
      <MantineTextInput
        {...props}
        data-pw={props['data-pw']}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoComplete={props.autoComplete ?? 'on'}
        data-floating={floating}
        labelProps={{ ...props.labelProps, 'data-floating': floating, 'data-error': props.error }}
      />
      {props.badgeMessage && (
        <Badge data-pw={`${props['data-pw']}-badge`} color={props.badgeColor} leftSection={props.badgeIcon} className={classes.badge} size="xs">
          {props.badgeMessage}
        </Badge>
      )}
    </Box>
  );
};
